<template>
    <v-container class="py-6">
        <v-img max-height="150" max-width="200" src="./Bilgros.png" class="mx-auto"></v-img>
        <!-- Titre principal -->
        <h2 class="text-h5 font-weight-bold mt-4">Politique de Confidentialité</h2>
        <p class="text-subtitle-2">Date d’entrée en vigueur : 07/04/2025</p>

        <!-- Introduction -->
        <p>
            Chez <strong>Bilgros</strong>, votre vie privée est notre priorité.
            Cette politique de confidentialité explique comment nous collectons,
            utilisons, divulguons et protégeons vos informations lorsque vous
            utilisez notre plateforme (site web ou application mobile). En utilisant
            notre service, vous acceptez les conditions décrites dans cette politique.
        </p>

        <!-- 1. Informations collectées -->
        <h3 class="text-h6 font-weight-bold mt-6">1. Informations collectées</h3>
        <p>
            <strong>a. Informations personnelles :</strong>
            nom complet, adresse e-mail, numéro de téléphone, adresse de livraison,
            données de paiement (via des prestataires sécurisés), photo de profil (si fournie).
            <br />
            <strong>b. Données d'utilisation :</strong>
            adresse IP, type d’appareil et système d’exploitation, type de navigateur, comportements de navigation.
            <br />
            <strong>c. Cookies et technologies de suivi :</strong>
            pour maintenir votre session, analyser l’utilisation et améliorer les fonctionnalités.
        </p>

        <!-- 2. Utilisation des données -->
        <h3 class="text-h6 font-weight-bold mt-6">2. Utilisation des données</h3>
        <p>
            Vos informations sont utilisées pour fournir et améliorer nos services,
            traiter les commandes, offrir une assistance client, détecter les fraudes,
            et vous envoyer des notifications et offres (avec possibilité de vous désabonner).
        </p>

        <!-- 3. Partage des informations -->
        <h3 class="text-h6 font-weight-bold mt-6">3. Partage des informations</h3>
        <p>
            Nous ne vendons pas vos données personnelles. Certaines données peuvent être partagées avec :
            partenaires de livraison, prestataires de paiement (ex. Stripe, PayPal), outils d’analyse (ex. Google
            Analytics),
            ou autorités légales si requis.
        </p>

        <!-- 4. Vos droits -->
        <h3 class="text-h6 font-weight-bold mt-6">4. Vos droits</h3>
        <p>
            Vous pouvez accéder, corriger ou supprimer vos données personnelles.
            Vous pouvez aussi désactiver les cookies ou refuser les messages marketing dans les paramètres.
        </p>

        <!-- 5. Sécurité des données -->
        <h3 class="text-h6 font-weight-bold mt-6">5. Sécurité des données</h3>
        <p>
            Nous utilisons des mesures de sécurité strictes comme le chiffrement SSL,
            un hébergement sécurisé, et des accès limités aux données sensibles.
        </p>

        <!-- 6. Services tiers -->
        <h3 class="text-h6 font-weight-bold mt-6">6. Services tiers</h3>
        <p>
            Notre application peut contenir des liens vers des sites ou services tiers.
            Veuillez consulter leurs politiques de confidentialité, car nous ne sommes pas responsables de leurs
            pratiques.
        </p>

        <!-- 7. Modifications de la politique -->
        <h3 class="text-h6 font-weight-bold mt-6">7. Modifications de la politique</h3>
        <p>
            Nous pouvons mettre à jour cette politique à tout moment.
            Toute modification sera affichée avec une nouvelle date d’entrée en vigueur.
        </p>

        <!-- 8. Contact -->
        <h3 class="text-h6 font-weight-bold mt-6">8. Contact</h3>
        <p>
            Pour toute question concernant cette politique, contactez-nous à : <br />
            📧 Email : <strong>Contact@bilgros.com</strong><br />
            📍 Adresse : Lac 2 immeuble Royal Garden<br />
            <!-- 📞 Téléphone : [Optionnel] -->
        </p>
    </v-container>
</template>

<style scoped>
p {
    margin-bottom: 12px;
    line-height: 1.6;
}
</style>